module.exports = __webpack_public_path__ + "img/GN.8b19e7f1.svg";